<template>
    <form id="mainForm" action="#" method="post">
        <Card>
            <template #title>
                <Toolbar>
                    <template #left>
                        <div class="p-card-title">
                           Manage PIC Edit WO Creation
                        </div>
                    </template>

                    <template #right>
                        <Button icon="pi pi-chevron-left" label="Back" class="p-button mr-2" @click="backToIndex" />
                        <Button icon="pi pi-save" label="Save" class="p-button-success" @click="confirm($event)" v-if="mode == this.$FORM_MODE_EDIT_PIC && canEdit" /> 
                        <ConfirmPopup></ConfirmPopup>
                    </template>
                </Toolbar>
            </template>
            <template #content>
                <div class="p-inputtext-sm p-fluid">
                    <div class="grid">
                        <div class="col-6">
                           
                            <FormField :labelName="$t('no_wo')" fieldName="WO_Number" v-model="header" labelClass="col-4" fieldClass="col-8">
                                <InputText  name="no_wo" v-model="header.Wo_Number"
                                :placeholder="$t('no_wo')" v-if="header" :useGrouping="false" :min="0"
                                :disabled=true />
                            </FormField>
                            <FormField :labelName="$t('reason')" fieldName="Reason" v-model="header" labelClass="col-4" fieldClass="col-8" v-if="header">
                                <InputText name="Reason" v-model="header.Reason" required="true" type="text"
                                    :placeholder="$t('reason')" v-if="header"/>
                                    <small v-if="header && !header.Reason && submitted"
                                        class="p-error">{{ $t('is_required').replace('Value', $t('reason')) }}
                                    </small>
                            </FormField>
                            <DataTable :loading="!header" :value="header ? header.PICs : null" responsiveLayout="scroll" class="p-datatable-sm editable-cells-table" :rowClass="hideRow" fieldClass="col-6">
                                <Column >
                                    <template #header>
                                        <Button label="" icon="pi pi-plus" class="p-button-primary p-mr-2 p-button-sm" @click="addDetail" :disabled="!canEdit" />
                                    </template>
                                    <template #body="slotProps">
                                        <Button icon="pi pi-minus" class="p-button-danger p-mr-2 p-button-sm" @click="deleteDetail(slotProps)" :disabled="!canEdit" />
                                    </template>
                                </Column>
                                <Column field="PIC_Username" :header="$t('PIC_WO')" key="PIC_Username" class="w-12">
                                    <template #body="slotProps">
                                        <CustomSelect 
                                            v-model="slotProps.data[slotProps.column.props.field]" 
                                            :url="$API_URL + 'list/listPICWo'" 
                                            :minLength="0" 
                                            :filter="true"
                                            :disabled="!canEdit"
                                            :params="{ 
                                                exclude_pics: this.excludePICs(slotProps.index),
                                                woId: header ? header.Id : 0
                                            }"
                                            @change="onCellEditComplete(slotProps)" 
                                            />
                                    </template>  
                                </Column>                                      
                            </DataTable>
                        </div>  
                        <div class="col-12 mt-4" v-if="this.mode != this.$FORM_MODE_CREATE">
                            <TabView>
                                <TabPanel :header="$t('log_history')">
                                    <ChangeHistory v-if="this.header" :modelValue="this.dataModelReqLogs"
                                        :dataRequestLog="this.dataRequestLogs" :mode="this.mode"></ChangeHistory>
                                </TabPanel>
                                <TabPanel :header="$t('Change_History')">
                                    <ChangeHistory v-if="this.header"  :tableName="'WorkOrderCreation'" :modelValue="this.detailLog" :dataRequestLog="this.dataChangesLog" :mode="this.mode"></ChangeHistory>
                                </TabPanel>
                            </TabView>
                        </div>
                    </div>
                </div>
            </template>
        </Card>
    </form>
</template>


<script>
import moment from 'moment';
export default {
    name: "Editor",
    data() {
        return {
            indexName: "WoReleaseIndex",
            url: this.$API_URL + "WoRelease/",
            header: null,
            mode: "",
            submitted: false,
            id: 0,
            mainid : 0,
            dataModelReqLogs: [],
            dataRequestLogs: [
                { field: "Action_Role", header: "Role" },
                { field: "Action_By", header: "Action By" },
                { field: "Table_Name", header: "Table Name" },
                { field: "Action", header: "Action" },
                { field: "Action_Date", header: "Action Date" },
                { field: "Notes", header: "Notes" },
            ],
            dataRelease: this.$dataRelease,
            detailLog : null,
            dataChangesLog:this.$dataChangesLog,
        }
    },
    methods: {
        excludePICs(index){
            var excludes = [];
            var PICs = this.header.PICs || [];
            for(var i=0; i< PICs.length;i++){
                var pic = PICs[i];
                if(pic.PIC_Username)
                    excludes.push(pic.PIC_Username);                
            }
            return excludes.join(";");
        },
        getData() {
            var self = this;
            this.$axios.get(this.url + this.id + "/" + this.mode)
                .then((response) => {
                    
                    if(!response.data.success){
                        self.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: this.$DEFAULT_TIMER });   
                        return;
                    }

                    self.header = response.data.data.header;
                    self.header.mode = self.mode;  
                    self.dataModelReqLogs = response.data.data.header.request_log_pic;
                    self.detailLog = self.header.DetailLog_pic;                             
                 
                })
                .catch(function (error) {
                    self.showError("Error", error);
                });
        },
        saveData() {
            this.$emit('block-ui');
            var self = this;
            this.$axios.post(this.$API_URL + "WoRelease/savePIC", this.header)
                .then((response) => {
                    if (response.data.success) {
                        if(self.header.mode == self.$FORM_MODE_CREATE)
                            self.$router.push({ name: self.indexName, params: { showToast: true, severity: 'success', summary: 'Data Saved', detail: "PIC Work Order has been successfully maintained", life: 3000 } });
                        else if(self.header.mode == self.$FORM_MODE_EDIT_PIC)
                            self.$router.push({ name: self.indexName, params: { showToast: true, severity: 'success', summary: 'Data Saved', detail: "PIC Work Order has been successfully maintained", life: 3000 } });
                        else if(self.header.mode == self.$FORM_MODE_DELETE)
                            self.$router.push({ name: self.indexName, params: { showToast: true, severity: 'success', summary: 'Data Saved', detail: "PIC Work Order has been successfully maintained", life: 3000 } });
                    }
                    else {
                        self.showError('Error Saving Data', response.data.message);
                    }
                })
                .catch(function (error) {
                    self.showError('Error Saving Data', error);
                });
        },
        showError(summary, message) {
            this.$emit('unblock-ui');
            this.$toast.add({ severity: 'error', summary: summary, detail: message, life: 3000 });
        },
        backToIndex() {
            if(this.$router.options.history.state.back != null)
                this.$router.push({ path: this.$router.options.history.state.back });
            else 
              this.$router.push({ path: "Index" });
        },
        toggle(event) {
            this.$refs.op.toggle(event);
        },
        confirm(event) {
            this.submitted = true;
            var self = this;
            if(!this.header.Reason)
            {
                return false;
            }
            if(!this.validationFromField())
            {
                this.showError('Error Saving Data', "PIC must not be empty");
                return false;
            }
                
            
            
            this.$confirm.require({
                target: event.currentTarget,
                message: 'Are you sure?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    this.saveData();
                },
                reject: () => {

                }
            });
            
        },
        validationFromField(){

            if (this.header && this.header.PICs && this.header.PICs.length > 0) {
                let invalid = this.header.PICs.some(pic => !pic.PIC_Username || pic.PIC_Username === "");
                if (invalid) {
                    
                    return false;
                }else{
                    return true;
                }
            }
        },
        hideRow(data) {
            return data.mode == this.$FORM_MODE_DELETE ? 'row-hidden' : null;
        },
        addDetail() {
            var newDetail = { 
                PIC_Username: null, 
                mode: this.$FORM_MODE_CREATE 
            };
            this.header.PICs.push(newDetail);
        },
        deleteDetail(event) {
            if (event) {
                var detail = this.header.PICs[event.index];

                if (detail.mode == this.$FORM_MODE_CREATE) this.header.PICs.splice(this.header.PICs.indexOf(detail), 1);
                else detail.mode = this.$FORM_MODE_DELETE;
            }
        },
        onCellEditComplete(event) {
            this.editDetail(event.index);
        },
        editDetail(index) {
            if (this.header && this.header.PICs) {
                let mode = this.header.PICs[index].mode;

                if (mode == this.$FORM_MODE_UNCHANGED) {
                    this.header.PICs[index].mode = this.$FORM_MODE_EDIT;
                }
            }
        },

    },
    computed:{
        canEdit() {
            if (!this.header) return false; 
            return !(this.header.Status == this.$APPROVAL_STATUS.CANCELLED|| this.header.Is_Deleted === "Y");
        },
    },
    created() {
        this.mode = this.$route.query.mode;
        this.id = this.$route.query.id ?? 0;
    
        debugger;
        this.mainid = this.$route.query.mainid ?? 0;
        if(this.$router.options.history.state.back != null){
            var indexName = this.$router.options.history.state.back.split("/");
            if(indexName[1] == "MainData")
                this.indexName = "MainDataIndex";
        }
        this.getData();
    }
}
</script>